import React from 'react';

import { always } from 'ramda';

import LandingPage from 'components/shared/LandingPage';
import PageHeader from 'components/shared/LandingPage/blocks/PageHeader';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import { useCustomStylesWatcher } from 'hooks/useCustomStylesWatcher';

import { useLandingContext } from './functions';
import s from './index.module.css';

const defaultRenderPageHeader = ({ links, hideBurgerMenu }) => (
  <PageHeader renderIcons={always(null)} links={links} disabled hideBurgerMenu={hideBurgerMenu} />
);

function Builder(props) {
  const { links, renderPageHeader = defaultRenderPageHeader, headlineHint } = props;
  const contextValue = useLandingContext(props);
  useCustomStylesWatcher({ pageId: props?.page?.id });

  return (
    <LandingPageContext.Provider value={contextValue}>
      {renderPageHeader({ links, hideBurgerMenu: props.hideBurgerMenu })}
      <LandingPage
        className={s.builder}
        landingPageType={props.page.type}
        hideBurgerMenu={props.hideBurgerMenu}
        headlineHint={headlineHint}
      />
    </LandingPageContext.Provider>
  );
}

export default Builder;
